'use client'

import React, { memo } from 'react'
import { cn } from '@/lib/utils'

interface ToggleSwitchProps {
  value: boolean
  onChange: (value: boolean) => void
  activeColor?: string
  title?: string
  ariaLabel?: string | ((value: boolean) => string)
}

const ToggleSwitch = memo<ToggleSwitchProps>(({
  value,
  onChange,
  activeColor = 'cyan',
  title,
  ariaLabel
}) => {
  const colorClasses = {
    cyan: 'bg-cyan-600',
    green: 'bg-green-600',
    purple: 'bg-purple-600',
    orange: 'bg-orange-600',
    red: 'bg-red-600',
    blue: 'bg-blue-600'
  }

  const getAriaLabel = () => {
    if (typeof ariaLabel === 'function') {
      return ariaLabel(value)
    }
    return ariaLabel
  }

  return (
    <button
      onClick={() => onChange(!value)}
      className={cn(
        "relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-cyan-400/50 focus:ring-offset-2",
        value ? colorClasses[activeColor as keyof typeof colorClasses] || colorClasses.cyan : "bg-slate-600"
      )}
      title={title}
      aria-label={getAriaLabel()}
    >
      <span
        className={cn(
          "inline-block h-4 w-4 transform rounded-full bg-white transition-transform",
          value ? "translate-x-6" : "translate-x-1"
        )}
      />
    </button>
  )
})

ToggleSwitch.displayName = 'ToggleSwitch'

export default ToggleSwitch